<template>
  <div class="row">
    <div class="col-12">
      <div class="subpage">
        <h1 class="subpage__headline" v-html="content.data.rules.header"></h1>
        <div class="subpage__rules" v-html="content.data.rules.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rules",
  title: "Regulamin",
  inject: ["content"],
  data() {
    return {
      title: "Rules page",
    };
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
